export const convertDictionaryToViewLabelArray = (dic) => {
    return Object.keys(dic)
        .map(key => ({
        value: key,
        label: dic[key],
    }));
};
